import { usePlatform } from "@platform/PlatformContext";
import { DashboardAlertBanner } from "./DashboardAlertBanner";

export function DashboardAlertBannerContainer() {
  const { alertMessage } = usePlatform();

  return <DashboardAlertBanner message={alertMessage} />;
}

export default DashboardAlertBannerContainer;
